import { STATUSPAGE } from '@repo/ui';
import { GetStudentsIndividualWorkloadReportUseCaseInterface } from 'domain/usecases';
import { notifyError } from 'presentation/app/components/notify';
import { useService } from 'presentation/app/hooks/useService';
import { useAppSelector } from 'presentation/config/hooks/useRedux';
import {
  clearStudentsCHI,
  saveStudentsCHI,
} from 'presentation/config/store/reports/students-individual-workload-report';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

export const useStudentsIndividualWorkloadReport = () => {
  const { studentsCHI } = useAppSelector((state) => state.studentsCHI);

  const dispatch = useDispatch();
  const { reportService } = useService();

  const [statusGet, setStatusGet] = useState<STATUSPAGE>();
  const [statusHandle, setStatusHandle] = useState<STATUSPAGE>();

  const requestHandleStudentsIndividualWorkload = useCallback(
    async (
      params?: GetStudentsIndividualWorkloadReportUseCaseInterface.Params,
    ) => {
      setStatusHandle(STATUSPAGE.LOADING);

      await reportService
        .getStudentsIndividualWorkloadReport(params)
        .then((res: any) => {
          let blob = new Blob([res], {
            type: `application/${params?.type === '0' ? 'pdf' : 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'}`,
          });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          window.open(link.href, '_blank');
        })
        .catch((err) => notifyError(err.message))
        .finally(() => {
          setStatusHandle(STATUSPAGE.DONE);
        });
    },
    [],
  );

  const requestGetStudentsIndividualWorkload = useCallback(
    async (
      params?: GetStudentsIndividualWorkloadReportUseCaseInterface.Params,
    ) => {
      setStatusGet(STATUSPAGE.LOADING);

      await reportService
        .getStudentsIndividualWorkloadReport(params)
        .then((res) => {
          dispatch(saveStudentsCHI(res));
        })
        .catch((err) => {
          dispatch(clearStudentsCHI());
          notifyError(
            err.message ||
              'Não há dados disponíveis para gerar o relatório. Verifique os critérios de busca!',
          );
        })
        .finally(() => {
          setStatusGet(STATUSPAGE.DONE);
        });
    },
    [],
  );

  return {
    statusGet,
    statusHandle,
    studentsCHI,
    requestGetStudentsIndividualWorkload,
    requestHandleStudentsIndividualWorkload,
  };
};
